/**
 * Copyright (C) Siemens AG 1996-2026 ALL RIGHTS RESERVED.
 */

import {Component, inject} from '@angular/core';
import {IxActiveModal} from '@siemens/ix-angular';
import {
  SubmodelType,
  getSubmodelIcon,
} from '../../../../models/dpp/submodel-types';

@Component({
  selector: 'app-modal-create-submodel',
  templateUrl: './modal-create-submodel.component.html',
  styleUrls: ['./modal-create-submodel.component.scss'],
  standalone: false,
})
export class ModalCreateSubmodelComponent {
  protected readonly activeModal: IxActiveModal = inject(IxActiveModal);
  protected readonly SubmodelType = SubmodelType;
  protected readonly getSubmodelIcon = getSubmodelIcon;

  selectedSubmodel?: SubmodelType;

  readonly allSubmodels: SubmodelType[] = [
    SubmodelType.DIGITAL_NAMEPLATE,
    SubmodelType.HANDOVER_DOCUMENTATION,
  ];
  readonly existingTypes: SubmodelType[];

  constructor() {
    this.existingTypes = this.activeModal.data?.existingTypes ?? [];
  }

  isDisabled(type: SubmodelType): boolean {
    return this.existingTypes.includes(type);
  }

  selectSubmodel(type: SubmodelType): void {
    if (this.isDisabled(type)) {
      return;
    }
    this.selectedSubmodel = type;
  }

  isAddButtonDisabled(): boolean {
    return !this.selectedSubmodel || this.isDisabled(this.selectedSubmodel);
  }

  onAdd(): void {
    if (!this.selectedSubmodel) {
      return;
    }
    this.activeModal.close(this.selectedSubmodel);
  }

  onCancel(): void {
    this.activeModal.dismiss('dismiss');
  }

  getSubmodelImageClass(type: SubmodelType): string {
    const imageClassMap: Partial<Record<SubmodelType, string>> = {
      [SubmodelType.DIGITAL_NAMEPLATE]: 'nameplate-image',
      [SubmodelType.HANDOVER_DOCUMENTATION]: 'handover-documentation-image',
    };
    return imageClassMap[type] ?? '';
  }
}
